import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    // 层级默认为3
    level: {
      type: Number,
      default: function _default() {
        return 3;
      }
    },
    // 接收数据[string, string, string]
    selfData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    selfData: {
      handler: function handler(v) {
        this.address = _toConsumableArray(v);
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      address: [],
      provinceData: [],
      cityData: [],
      areaData: [],
      itemData: [],
      props: {
        label: 'typeName',
        value: 'goodsTypeId'
      }
    };
  },
  created: function created() {
    this.getOne({
      typeLevel: 1
    });
  },
  methods: {
    //获取数据
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, o;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.goodsTypes(_objectSpread(_objectSpread({}, item), {}, {
                  pageNo: 1,
                  pageSize: 99
                }));

              case 2:
                res = _context.sent;
                o = res.records;
                return _context.abrupt("return", o);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //1级类目
    getOne: function getOne(item) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.dataBind(item);

              case 2:
                _this2.provinceData = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 选择1级类目
    changeProvince: function changeProvince(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, item;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                params = {
                  typeLevel: 2,
                  preTypeId: e[0]
                };
                _context3.next = 3;
                return _this3.dataBind(params);

              case 3:
                _this3.cityData = _context3.sent;
                _this3.areaData = [];
                _this3.address[1] = '';
                _this3.address[2] = '';
                item = _this3.$refs.panel1.menus[0].find(function (v) {
                  return v.value == e[0];
                });
                _this3.itemData = [];
                _this3.itemData[0] = item;

                _this3.$emit('change', [e[0]], _this3.itemData);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 选择2级类目
    changeCity: function changeCity(e) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, item;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {
                  typeLevel: 3,
                  preTypeId: e[0]
                };
                _context4.next = 3;
                return _this4.dataBind(params);

              case 3:
                _this4.areaData = _context4.sent;
                _this4.address[2] = '';
                item = _this4.$refs.panel2.menus[0].find(function (v) {
                  return v.value == e[0];
                });

                _this4.itemData.splice(1, 2);

                _this4.itemData[1] = item;

                _this4.$emit('change', [_this4.address[0][0], e[0]], _this4.itemData);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 选择区县
    changeArea: function changeArea(e) {
      var list = this.address.map(function (v) {
        return v[0];
      });
      var item = this.$refs.panel3.menus[0].find(function (v) {
        return v.value == e[0];
      });
      this.itemData[2] = item;
      this.$emit('change', list, this.itemData);
    }
  }
};